<div class="benefit-card"
     role="button"
     tabindex="0"
     (click)="onClick()"
     (keydown)="onKeydown($event)"
     (keyup)="onKeyup($event)">

  <span class="benefit-card__figure" *ngIf="hasImagery" [class.benefit-card__figure--logo-only]="!coverUrl">
    <img *ngIf="coverUrl" class="benefit-card__image" [src]="coverUrl" alt="" loading="lazy" decoding="async"
         (load)="onCoverLoad($event)"
         (error)="onCoverError($event)" />
    <span class="benefit-card__logo">
      <img *ngIf="logoUrl && !logoFailed" [src]="logoUrl" alt="" loading="lazy" decoding="async"
           (load)="onLogoLoad($event)"
           (error)="onLogoError()" />
    </span>
  </span>

  <div class="benefit-card__body">
    <div class="benefit-card__heading" *ngIf="benefit?.name" [innerHTML]="benefit?.name"></div>
    <div class="benefit-card__text" *ngIf="benefit?.teaser" [innerHTML]="benefit?.teaser"></div>
  </div>

  <span class="benefit-card__meta">
    <span class="benefit-card__meta-item" *ngIf="benefit?.bonusText">
      <span class="benefit-card__icn"><i class="bi bi-gift" aria-hidden="true"></i></span>
      <span class="benefit-card__meta-label" [innerHTML]="benefit?.bonusText"></span>
    </span>
    <span class="benefit-card__meta-item" *ngIf="showDiscountBadge">
      <span class="benefit-card__icn"><i class="bi" [ngClass]="isWebShop ? 'bi-shop' : 'bi-percent'" aria-hidden="true"></i></span>
      <span class="benefit-card__meta-label" [innerHTML]="benefit?.discountText"></span>
    </span>
  </span>

</div>
